import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
 
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import tEN from './locales/en/translation.json'
import tZH from './locales/zh/translation.json'

const resources ={
    en: {
        translation: tEN
    },
    zh:{
        translation:tZH
    },
};  

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng:'en',
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['path', 'cookie', 'htmlTag', 'localStorage', 'subdomain'],  
      caches: ['cookie'],
    },
    interpolation:{
      escapeValue:false,
    },
      react: {
        wait: true
      },
  });
 
export default i18n;